import Version from './version.vue'
export default Version
